import { VAxios } from '../../define/axios/Axios';

/**
 * inpaint 相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 导出 psd
  exportPSD: (id) => {
    return defHttp.get({
      url: `/aiad/psd/export/${id}`,
    });
  },

  // 导出 psd v2
  exportPSDV2: (id, design) => {
    return defHttp.post({
      url: `/aiad/psd/export/v2/${id}`,
      params: design,
    });
  },
});
